import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowPolygon } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexBetween } from '../../../styles/stylesStyled';
import {
  ExpandedDiv,
  Level,
  LevelExpanded,
  LevelNum,
  LevelSmallText,
  LevelTitle
} from './VolumePointsStyled';

const Week = ({ level }) => {
  const { t } = useTranslation('myTeam');
  const [expand, setExpand] = useState(false);

  return (
    <>
      <Level
        onClick={() => setExpand(expand === 1 ? '' : 1)}
        expand={expand === 1}
        isLocked={level.isLocked}>
        <FlexBetween style={{ width: 'calc(100% - 30px )' }}>
          <LevelTitle>
            {`${t('generations_page.generation')} ${level?.level}`}{' '}
          </LevelTitle>
          <LevelTitle>
            {t('generations_page.total')}:{' '}
            {level.levelUsersCount !== null ? level.levelUsersCount : 0}
          </LevelTitle>
        </FlexBetween>

        <ArrowPolygon
          customColor={
            level.isLocked ? color.colors.neutral400 : color.colors.neutral50
          }
          direction={
            expand === 1
              ? t('generations_page.down')
              : t('generations_page.right')
          }
        />
      </Level>
      <LevelExpanded expand={expand === 1}>
        <ExpandedDiv>
          <div>
            <LevelSmallText>{t('generations_page.today')}</LevelSmallText>
            <LevelNum>{`+${level.todayChange}`}</LevelNum>
          </div>
          <div>
            <LevelSmallText>{t('generations_page.this_week')}</LevelSmallText>
            <LevelNum>{`+${level.weekChange}`}</LevelNum>
          </div>
          <div>
            <LevelSmallText>{t('generations_page.this_month')}</LevelSmallText>
            <LevelNum>{`+${level.monthChange}`}</LevelNum>
          </div>
        </ExpandedDiv>
      </LevelExpanded>
    </>
  );
};

export default Week;
